import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDecimal,
  ODataEnum
} from "pbas-vue-components";
import { i18n } from '@/plugins/i18n';
import store from "@/store";

function getHeaders(reasons) {
  return [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1,
    }),
    new ODataHeader({
      title: "globals.start_date",
      type: new ODataDate("StartDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.end_date",
      type: new ODataDate("EndDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.amount",
      type: new ODataDecimal("Amount"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.hourshistory.reason_code",
      type: new ODataEnum("Code", {
        getString: (item) => {
          return i18n.t("enums." + item.Code);
        },
        dropdownItems: reasons
      }),
  
      sortable: true,
      visible: false,
      searchable: true,
      allowVisibilityChange: false,
      version: 1
    }),
    new ODataHeader({
      type: new ODataDate("ChangedAt"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataDate("DeletedAt"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "headers.hourshistory.reported_at",
      type: new ODataDate("CreatedAt", {
        getString: (item, type) => {
          function parseValue(dateString) {
            if (dateString === undefined || dateString === null) {
                return "";
            }
            const [date, time] = dateString.split("T");
            const [year, month, day] = date.split("-");
            return `${year}-${month}-${day}`;
          }
          let parsed = "";
          if (item.ChangedAt) {
            parsed = parseValue(item.ChangedAt);
          } else {
            parsed = parseValue(item.CreatedAt);
          }
          return parsed;
        }
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      type: new ODataString("EmployerTranslations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
     }),
     new ODataHeader({
      title: "headers.pendinghourreports.Employer",
      type: new ODataString("EmployerTranslations[]/Name", {
        getString: (item) => translate2(item)
      }),
      sortable: false,
      visible: true,
      searchable: true,
      version: 1,
    })
  ];
}
function translate2(item) {
  const lang = store.getters["common/language"];
  // console.log(item, field, lang)
  if (item === null || item === undefined) return "";
  if (item.EmployerTranslations === null || item.EmployerTranslations === undefined)
    return "";
  const trans = item.EmployerTranslations.filter(
    (o) => o.LanguageCode === lang.language,
  );
  if (trans.length > 0)
    if (Object.keys(trans[0]).indexOf("Name") > -1)
      return trans[0].Name || "";
  return "";
};
export default getHeaders;
